export default {
  name: 'MiniProgress',
  props: ['target', 'color', 'percent', 'height']
};